import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.95 11.214a.5.5 0 1 1 .816.577l-1.159 1.638h1.608a.5.5 0 0 1 .405.79l-.56.781-.718 1-.436.606a.5.5 0 0 1-.812-.583L11.11 16l.718-1 .41-.571h-1.596a.5.5 0 0 1-.409-.79z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.357 5.877c.207 0 .375.168.375.375v2.625a.375.375 0 0 1-.375.375H7.643a.375.375 0 0 1-.375-.375V6.252c0-.207.168-.375.375-.375h7.714m-7.34 2.625H9.84V6.627H8.018zm2.572 0h1.821V6.627H10.59zm2.571 0h1.822V6.627H13.16z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.499 4.001a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-14a.5.5 0 0 1 .5-.5zm-11.5 14h11v-13h-11v13",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.829 15h1.23l-.717 1H11.11zM15 9.252h-1v-.75h.982V6.627H14v-.75h1zM5.999 15H3V2h11v3.001h1V1.75a.75.75 0 0 0-.75-.75H2.75a.75.75 0 0 0-.75.75v13.5a.75.75 0 0 0 .673.746L2.75 16h3.249z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }